// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8ab44547","732":"6d41c2e9","977":"ce2eb3e4"}[chunkId] + ".chunk.js";
};